var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"fx fx-y-center fx-x-between"},[_c('div',{staticClass:"logo-cont",on:{"click":_vm.gotoOfficial}})])
}
var staticRenderFns = []

export { render, staticRenderFns }